var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('portal',{attrs:{"to":_setup.portalTarget}},[_c('div',{class:[
        'serp-lead-banner-wrapper', 
        `serp-lead-banner-wrapper_${_setup.visibleType}`, 
        {
            'serp-lead-banner-wrapper_mobile': _vm.mobile, 
        }
    ]},[(_setup.isBannerVisible)?_c(_setup.LeadBanner,{ref:"formRef",class:[
                'serp-lead-banner', 
                `serp-lead-banner_${_setup.visibleType}`,
                {
                   'serp-lead-banner_mobile': _vm.mobile, 
                }
            ],style:({ ..._setup.anchorPosition }),attrs:{"size":"m","mobile":_vm.mobile,"zIndex":1000,"title":_setup.title,"subtitle":_setup.subtitle,"subtitleVariant":_setup.subtitleVariant,"loading":_setup.loading,"isSubmitted":_setup.isSubmitted,"user-agreement-url":_setup.getLegalDocumentUrl('user_agreement'),"privacy-policy-url":_setup.getLegalDocumentUrl('privacy'),"data-processing-url":_setup.getLegalDocumentUrl('personal_data_agreement')},on:{"submit":_setup.onSubmit},model:{value:(_setup.model),callback:function ($$v) {_setup.model=$$v},expression:"model"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }